/**
 * Sola Busca card art (15th century, public domain).
 *
 * Bundled via Parcel `url:` imports (the same pattern as arrow.webp), so the
 * URLs work identically in the parcel dev server, the nginx production image and
 * the Capacitor webview. Keyed by exact file name.
 */
import img_00_mato from 'url:../../../assets/images/sola-busca/00-mato.jpg';
import img_01_panfilio from 'url:../../../assets/images/sola-busca/01-panfilio.jpg';
import img_02_postumio from 'url:../../../assets/images/sola-busca/02-postumio.jpg';
import img_03_lenpio from 'url:../../../assets/images/sola-busca/03-lenpio.jpg';
import img_04_mario from 'url:../../../assets/images/sola-busca/04-mario.jpg';
import img_05_catulo from 'url:../../../assets/images/sola-busca/05-catulo.jpg';
import img_06_sesto from 'url:../../../assets/images/sola-busca/06-sesto.jpg';
import img_07_deo_tauro from 'url:../../../assets/images/sola-busca/07-deo-tauro.jpg';
import img_08_nerone from 'url:../../../assets/images/sola-busca/08-nerone.jpg';
import img_09_falco from 'url:../../../assets/images/sola-busca/09-falco.jpg';
import img_10_venturio from 'url:../../../assets/images/sola-busca/10-venturio.jpg';
import img_11_tulio from 'url:../../../assets/images/sola-busca/11-tulio.jpg';
import img_12_carbone from 'url:../../../assets/images/sola-busca/12-carbone.jpg';
import img_13_catone from 'url:../../../assets/images/sola-busca/13-catone.jpg';
import img_14_bocho from 'url:../../../assets/images/sola-busca/14-bocho.jpg';
import img_15_metelo from 'url:../../../assets/images/sola-busca/15-metelo.jpg';
import img_16_olivo from 'url:../../../assets/images/sola-busca/16-olivo.jpg';
import img_17_ipeo from 'url:../../../assets/images/sola-busca/17-ipeo.jpg';
import img_18_lentulo from 'url:../../../assets/images/sola-busca/18-lentulo.jpg';
import img_19_sabino from 'url:../../../assets/images/sola-busca/19-sabino.jpg';
import img_20_nenbroto from 'url:../../../assets/images/sola-busca/20-nenbroto.jpg';
import img_21_nabucho_denasor from 'url:../../../assets/images/sola-busca/21-nabucho-denasor.jpg';
import img_back from 'url:../../../assets/images/sola-busca/back.svg';
import img_batons_02 from 'url:../../../assets/images/sola-busca/batons-02.jpg';
import img_batons_03 from 'url:../../../assets/images/sola-busca/batons-03.jpg';
import img_batons_04 from 'url:../../../assets/images/sola-busca/batons-04.jpg';
import img_batons_05 from 'url:../../../assets/images/sola-busca/batons-05.jpg';
import img_batons_06 from 'url:../../../assets/images/sola-busca/batons-06.jpg';
import img_batons_07 from 'url:../../../assets/images/sola-busca/batons-07.jpg';
import img_batons_08 from 'url:../../../assets/images/sola-busca/batons-08.jpg';
import img_batons_09 from 'url:../../../assets/images/sola-busca/batons-09.jpg';
import img_batons_10 from 'url:../../../assets/images/sola-busca/batons-10.jpg';
import img_batons_ace from 'url:../../../assets/images/sola-busca/batons-ace.jpg';
import img_batons_king from 'url:../../../assets/images/sola-busca/batons-king.jpg';
import img_batons_knave from 'url:../../../assets/images/sola-busca/batons-knave.jpg';
import img_batons_knight from 'url:../../../assets/images/sola-busca/batons-knight.jpg';
import img_batons_queen from 'url:../../../assets/images/sola-busca/batons-queen.jpg';
import img_coins_02 from 'url:../../../assets/images/sola-busca/coins-02.jpg';
import img_coins_03 from 'url:../../../assets/images/sola-busca/coins-03.jpg';
import img_coins_04 from 'url:../../../assets/images/sola-busca/coins-04.jpg';
import img_coins_05 from 'url:../../../assets/images/sola-busca/coins-05.jpg';
import img_coins_06 from 'url:../../../assets/images/sola-busca/coins-06.jpg';
import img_coins_07 from 'url:../../../assets/images/sola-busca/coins-07.jpg';
import img_coins_08 from 'url:../../../assets/images/sola-busca/coins-08.jpg';
import img_coins_09 from 'url:../../../assets/images/sola-busca/coins-09.jpg';
import img_coins_10 from 'url:../../../assets/images/sola-busca/coins-10.jpg';
import img_coins_ace from 'url:../../../assets/images/sola-busca/coins-ace.jpg';
import img_coins_king from 'url:../../../assets/images/sola-busca/coins-king.jpg';
import img_coins_knave from 'url:../../../assets/images/sola-busca/coins-knave.jpg';
import img_coins_knight from 'url:../../../assets/images/sola-busca/coins-knight.jpg';
import img_coins_queen from 'url:../../../assets/images/sola-busca/coins-queen.jpg';
import img_cups_02 from 'url:../../../assets/images/sola-busca/cups-02.jpg';
import img_cups_03 from 'url:../../../assets/images/sola-busca/cups-03.jpg';
import img_cups_04 from 'url:../../../assets/images/sola-busca/cups-04.jpg';
import img_cups_05 from 'url:../../../assets/images/sola-busca/cups-05.jpg';
import img_cups_06 from 'url:../../../assets/images/sola-busca/cups-06.jpg';
import img_cups_07 from 'url:../../../assets/images/sola-busca/cups-07.jpg';
import img_cups_08 from 'url:../../../assets/images/sola-busca/cups-08.jpg';
import img_cups_09 from 'url:../../../assets/images/sola-busca/cups-09.jpg';
import img_cups_10 from 'url:../../../assets/images/sola-busca/cups-10.jpg';
import img_cups_ace from 'url:../../../assets/images/sola-busca/cups-ace.jpg';
import img_cups_king from 'url:../../../assets/images/sola-busca/cups-king.jpg';
import img_cups_knave from 'url:../../../assets/images/sola-busca/cups-knave.jpg';
import img_cups_knight from 'url:../../../assets/images/sola-busca/cups-knight.jpg';
import img_cups_queen from 'url:../../../assets/images/sola-busca/cups-queen.jpg';
import img_swords_02 from 'url:../../../assets/images/sola-busca/swords-02.jpg';
import img_swords_03 from 'url:../../../assets/images/sola-busca/swords-03.jpg';
import img_swords_04 from 'url:../../../assets/images/sola-busca/swords-04.jpg';
import img_swords_05 from 'url:../../../assets/images/sola-busca/swords-05.jpg';
import img_swords_06 from 'url:../../../assets/images/sola-busca/swords-06.jpg';
import img_swords_07 from 'url:../../../assets/images/sola-busca/swords-07.jpg';
import img_swords_08 from 'url:../../../assets/images/sola-busca/swords-08.jpg';
import img_swords_09 from 'url:../../../assets/images/sola-busca/swords-09.jpg';
import img_swords_10 from 'url:../../../assets/images/sola-busca/swords-10.jpg';
import img_swords_ace from 'url:../../../assets/images/sola-busca/swords-ace.jpg';
import img_swords_king from 'url:../../../assets/images/sola-busca/swords-king.jpg';
import img_swords_knave from 'url:../../../assets/images/sola-busca/swords-knave.jpg';
import img_swords_knight from 'url:../../../assets/images/sola-busca/swords-knight.jpg';
import img_swords_queen from 'url:../../../assets/images/sola-busca/swords-queen.jpg';

export const SOLA_BUSCA_IMAGE_URLS: Readonly<Record<string, string>> = {
    '00-mato.jpg': img_00_mato,
    '01-panfilio.jpg': img_01_panfilio,
    '02-postumio.jpg': img_02_postumio,
    '03-lenpio.jpg': img_03_lenpio,
    '04-mario.jpg': img_04_mario,
    '05-catulo.jpg': img_05_catulo,
    '06-sesto.jpg': img_06_sesto,
    '07-deo-tauro.jpg': img_07_deo_tauro,
    '08-nerone.jpg': img_08_nerone,
    '09-falco.jpg': img_09_falco,
    '10-venturio.jpg': img_10_venturio,
    '11-tulio.jpg': img_11_tulio,
    '12-carbone.jpg': img_12_carbone,
    '13-catone.jpg': img_13_catone,
    '14-bocho.jpg': img_14_bocho,
    '15-metelo.jpg': img_15_metelo,
    '16-olivo.jpg': img_16_olivo,
    '17-ipeo.jpg': img_17_ipeo,
    '18-lentulo.jpg': img_18_lentulo,
    '19-sabino.jpg': img_19_sabino,
    '20-nenbroto.jpg': img_20_nenbroto,
    '21-nabucho-denasor.jpg': img_21_nabucho_denasor,
    'back.svg': img_back,
    'batons-02.jpg': img_batons_02,
    'batons-03.jpg': img_batons_03,
    'batons-04.jpg': img_batons_04,
    'batons-05.jpg': img_batons_05,
    'batons-06.jpg': img_batons_06,
    'batons-07.jpg': img_batons_07,
    'batons-08.jpg': img_batons_08,
    'batons-09.jpg': img_batons_09,
    'batons-10.jpg': img_batons_10,
    'batons-ace.jpg': img_batons_ace,
    'batons-king.jpg': img_batons_king,
    'batons-knave.jpg': img_batons_knave,
    'batons-knight.jpg': img_batons_knight,
    'batons-queen.jpg': img_batons_queen,
    'coins-02.jpg': img_coins_02,
    'coins-03.jpg': img_coins_03,
    'coins-04.jpg': img_coins_04,
    'coins-05.jpg': img_coins_05,
    'coins-06.jpg': img_coins_06,
    'coins-07.jpg': img_coins_07,
    'coins-08.jpg': img_coins_08,
    'coins-09.jpg': img_coins_09,
    'coins-10.jpg': img_coins_10,
    'coins-ace.jpg': img_coins_ace,
    'coins-king.jpg': img_coins_king,
    'coins-knave.jpg': img_coins_knave,
    'coins-knight.jpg': img_coins_knight,
    'coins-queen.jpg': img_coins_queen,
    'cups-02.jpg': img_cups_02,
    'cups-03.jpg': img_cups_03,
    'cups-04.jpg': img_cups_04,
    'cups-05.jpg': img_cups_05,
    'cups-06.jpg': img_cups_06,
    'cups-07.jpg': img_cups_07,
    'cups-08.jpg': img_cups_08,
    'cups-09.jpg': img_cups_09,
    'cups-10.jpg': img_cups_10,
    'cups-ace.jpg': img_cups_ace,
    'cups-king.jpg': img_cups_king,
    'cups-knave.jpg': img_cups_knave,
    'cups-knight.jpg': img_cups_knight,
    'cups-queen.jpg': img_cups_queen,
    'swords-02.jpg': img_swords_02,
    'swords-03.jpg': img_swords_03,
    'swords-04.jpg': img_swords_04,
    'swords-05.jpg': img_swords_05,
    'swords-06.jpg': img_swords_06,
    'swords-07.jpg': img_swords_07,
    'swords-08.jpg': img_swords_08,
    'swords-09.jpg': img_swords_09,
    'swords-10.jpg': img_swords_10,
    'swords-ace.jpg': img_swords_ace,
    'swords-king.jpg': img_swords_king,
    'swords-knave.jpg': img_swords_knave,
    'swords-knight.jpg': img_swords_knight,
    'swords-queen.jpg': img_swords_queen,
} as const;
